export enum DeliveryPayer{
    Sender,
    Receiver
}